import { For, Show, createSignal } from "solid-js"
import CreateNameDialog from "./CreateNameDialog"
import { DataTypes, useLocalStore } from "@/context/StateContext"
import Types from "@/types"
import Name from "@/components/Name"

type Props = {
  value: string | null
  onChange: (categoryId: string) => Promise<void>
  categories: any[] | null
}

export default function CategorySelect(props: Props) {
  const selectId = 'category-select'

  return (
    <div class="flex flex-col space-y-2">
      <label class="text-sm font-medium text-gray-700 dark:text-gray-300">
        Category
      </label>

      <div class="relative">
        <button
          popovertarget={selectId}
          type="button"
          class="flex w-full items-center justify-between rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 px-4 py-2.5 text-sm text-gray-900 dark:text-gray-100"
        >
          <span>{props.value ? <Name id={props.value} /> : 'Select category'}</span>
          <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
          </svg>
        </button>

        <div
          id={selectId}
          popover="auto"
          class="w-full rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 shadow-lg"
          style={{ "anchor-name": "bottom" }}
        >
          <CreateNameDialog
            onCreate={props.onChange}
            categoryType={Types.Category}
            label="Create new category"
          />

          <div class="border-t border-gray-100 dark:border-gray-700">
            <ul class="max-h-60 overflow-auto py-1">
              <Show when={props.categories} fallback={
                <li class="px-3 py-2 text-sm text-gray-500 dark:text-gray-400 text-center">
                  Loading...
                </li>
              }>
                <For each={props.categories}>{(category: any) => (
                  <li>
                    <button
                      onClick={async () => {
                        await props.onChange(category.origin)
                        document.getElementById(selectId)?.hidePopover()
                      }}
                      class="flex w-full items-center px-3 py-2 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700"
                    >
                      <Name id={category.origin} />
                    </button>
                  </li>
                )}
                </For>
              </Show>
            </ul>
          </div>
        </div>
      </div>
    </div>
  )
}
